var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn bg-primary text-white rounded-full text-center",class:[_vm.hasBorder ? '' : 'border border-solid border-white']},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }